import { createContext, Dispatch } from 'react';

import { areCookiesAccepted, areCookiesRejected } from 'app/api/cookie';
import { ParsedToken } from 'app/utils/lib/string';

export interface State {
  areCookiesAllowed: boolean | null;
  authRoles: number[];
  companyId: null | string;
  tokenData: null | ParsedToken;
}

interface ResetAction {
  type: 'reset';
}
interface SetLoginInfoAction {
  payload: {
    token: string;
  };
  type: 'setLoginInfo';
}
interface UpdateCookiePermission {
  payload: {
    areCookiesAllowed: boolean;
  };
  type: 'updateCookiePermission';
}

export type AuthContextAction =
  | ResetAction
  | SetLoginInfoAction
  | UpdateCookiePermission;

export type AuthDispatch = Dispatch<AuthContextAction>;

function getAreCookiesAllowed() {
  if (areCookiesAccepted()) {
    return true;
  }

  if (areCookiesRejected()) {
    return false;
  }

  return null;
}

export const initialState: State = {
  areCookiesAllowed: getAreCookiesAllowed(),
  authRoles: [],
  companyId: null,
  tokenData: null,
};

export const AuthStateContext = createContext<State>(initialState);
export const AuthDispatchContext = createContext<AuthDispatch>(undefined as unknown as AuthDispatch);

AuthStateContext.displayName = 'AuthState';
AuthDispatchContext.displayName = 'AuthDispatch';
